import { Box, Heading, VStack } from '@chakra-ui/react';
import React from 'react';
import PoolRankingDetails from './PoolRankingDetails';
import PoolRankingStepFunctionProgress from './PoolRankingStepFunctionProgress';

const PoolRankingProgressSteps = ({ timeStamp }) => {
  return (
    <VStack>
      <Heading>Pool ranking progress</Heading>
      <br />
      <Box borderWidth="3px" borderRadius="lg" p="10" width="1050px">
        <PoolRankingDetails timeStamp={timeStamp} />
        <PoolRankingStepFunctionProgress status={timeStamp?.status} />
      </Box>
    </VStack>
  );
};

export default PoolRankingProgressSteps;
